export enum MeasureUnitEnum {
  Meters = 'meters',
  Kilometers = 'kilometers',
  Miles = 'miles',
  Feet = 'feet',
  Yards = 'yards',
  SquareMeters = 'square-meters',
  Hectares = 'hectares',
  Acres = 'acres',
  SquareKilometers = 'square-kilometers',
  SquareMiles = 'square-miles',
  SquareFeet = 'square-feet',
  SquareYards = 'square-yards',
}

export namespace MeasureUnitEnum {
  export const LINEAR: MeasureUnitEnum[] = [
    MeasureUnitEnum.Meters,
    MeasureUnitEnum.Kilometers,
    MeasureUnitEnum.Miles,
    MeasureUnitEnum.Feet,
    MeasureUnitEnum.Yards,
  ];

  export const AREA: MeasureUnitEnum[] = [
    MeasureUnitEnum.SquareMeters,
    MeasureUnitEnum.Hectares,
    MeasureUnitEnum.Acres,
    MeasureUnitEnum.SquareKilometers,
    MeasureUnitEnum.SquareMiles,
    MeasureUnitEnum.SquareFeet,
    MeasureUnitEnum.SquareYards,
  ];

  export const LABELS: Record<MeasureUnitEnum, string> = {
    [MeasureUnitEnum.Meters]: 'm',
    [MeasureUnitEnum.Kilometers]: 'km',
    [MeasureUnitEnum.Miles]: 'mi',
    [MeasureUnitEnum.Feet]: 'ft',
    [MeasureUnitEnum.Yards]: 'yd',
    [MeasureUnitEnum.SquareMeters]: 'm²',
    [MeasureUnitEnum.Hectares]: 'ha',
    [MeasureUnitEnum.Acres]: 'ac',
    [MeasureUnitEnum.SquareKilometers]: 'km²',
    [MeasureUnitEnum.SquareMiles]: 'mi²',
    [MeasureUnitEnum.SquareFeet]: 'ft²',
    [MeasureUnitEnum.SquareYards]: 'yd²',
  };

  export function isLinear(u: MeasureUnitEnum): boolean {
    return LINEAR.includes(u);
  }

  export function isArea(u: MeasureUnitEnum): boolean {
    return AREA.includes(u);
  }
}
